import { useEffect } from "react";

export default function Toast({ messages, onDismiss, notification, onDismissNotification }) {
  useEffect(() => {
    if (!messages?.length) return;
    const t = setTimeout(onDismiss, 3000);
    return () => clearTimeout(t);
  }, [messages, onDismiss]);

  useEffect(() => {
    if (!notification) return;
    // Prompts that ask for a decision (a freed waitlist spot) pass a longer
    // duration than a plain confirmation needs.
    const t = setTimeout(onDismissNotification, notification.duration ?? 5000);
    return () => clearTimeout(t);
  }, [notification, onDismissNotification]);

  if (!messages?.length && !notification) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-4 z-50 flex flex-col gap-2 items-stretch sm:items-end">
      {notification && (
        <div className="bg-gray-800 text-white rounded-lg shadow-lg px-4 py-3 flex items-center gap-3 sm:min-w-[260px] max-w-sm sm:ml-auto">
          <span className="text-sm flex-1">{notification.message}</span>
          {notification.onAct && notification.actionLabel && (
            <button
              onClick={() => { notification.onAct(); onDismissNotification(); }}
              className="text-green-300 hover:text-green-100 text-sm font-semibold transition-colors whitespace-nowrap"
            >
              {notification.actionLabel}
            </button>
          )}
          {notification.onUndo && (
            <button
              onClick={() => { notification.onUndo(); onDismissNotification(); }}
              className="text-blue-300 hover:text-blue-100 text-sm font-semibold transition-colors whitespace-nowrap"
            >
              Undo
            </button>
          )}
          <button onClick={onDismissNotification} className="text-gray-400 hover:text-white text-lg leading-none">×</button>
        </div>
      )}
      {messages?.length > 0 && (
        <div className="bg-amber-50 border border-amber-400 rounded-lg shadow-lg p-4 max-w-sm">
          <div className="flex items-start gap-2">
            <span className="text-amber-600 font-bold text-lg leading-none">&#x26A0;</span>
            <div>
              {messages.length === 1 ? (
                <p className="text-amber-800 text-sm">{messages[0]}</p>
              ) : (
                <ul className="text-amber-800 text-sm list-disc list-inside space-y-1">
                  {messages.map((m, i) => <li key={i}>{m}</li>)}
                </ul>
              )}
            </div>
            <button onClick={onDismiss} className="ml-auto text-amber-500 hover:text-amber-700 text-lg leading-none">&times;</button>
          </div>
        </div>
      )}
    </div>
  );
}
